import {
  createRouter,
  createWebHashHistory,
  // createWebHistory,
  NavigationGuardNext,
  RouteLocationNormalized
} from 'vue-router'

import routes from './routes'

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

/**
 * Routing to intercept
 */
router.beforeEach(
  async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) => {
    next()
  }
)

export default router
